module.exports = __webpack_public_path__ + "static/vrtwinslogo.a2ac8c42.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vrtwinslogo.png
// module id = 457
// module chunks = 79611799117203